import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  fetchSetupStepsError,
  fetchSetupStepsSuccess,
  toggleDismissError,
  toggleDismissSuccess,
} from './actions'
import { FETCH_BASIC_SETUP_ASYNC, TOGGLE_DISMISS_ASYNC } from './constants'

const fetchSetupStepsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_BASIC_SETUP_ASYNC.INITIATE, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
    .mergeMap(() =>
      api.accounts
        .getSetupSteps(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => fetchSetupStepsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchSetupStepsError, error, [400])))
        .takeUntil(action$.ofType(FETCH_BASIC_SETUP_ASYNC.CANCEL))
    )

const toggleDismissEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(TOGGLE_DISMISS_ASYNC.INITIATE).mergeMap((action) =>
    api.accounts
      .dismissStep(store.getState().partnerOptions.selectedCompany?.value, action.payload.body)
      .map(() => toggleDismissSuccess(action.payload.body))
      .catch((error) => Observable.of(epicsErrorHandler(toggleDismissError, error)))
      .takeUntil(action$.ofType(TOGGLE_DISMISS_ASYNC.CANCEL))
  )

export default combineEpics(fetchSetupStepsEpic, toggleDismissEpic)
